import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementSpellCheckDictionaries(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementSpellCheckDictionaries?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementSpellCheckDictionaries", responseData.data);
  },

  async postEngagementSpellCheckDictionary(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementSpellCheckDictionary`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementSpellCheckDictionary(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementSpellCheckDictionary`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementSpellCheckDictionary(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementSpellCheckDictionary`,
      "POST",
      null,
      postData
    );
  },
};
